/* eslint-disable */
import { produce } from "immer";
import {
  COMM_PREFERENCE_FETCH_FAILURE,
  COMM_PREFERENCE_FETCH_START,
  COMM_PREFERENCE_FETCH_SUCCESS,
} from "../actions/types";

const commPref = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case COMM_PREFERENCE_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case COMM_PREFERENCE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case COMM_PREFERENCE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default commPref;
